module.exports = __webpack_public_path__ + "img/info.a3a75666.jpg";